import { Mail, Phone } from 'lucide-react'
import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Button } from '../../shared/button/button'
import { Stack } from '../../shared/stack/Stack'

export type FooterContactActionsProps = {
  email: string
  phone: string
}

export const FooterContactActions = forwardRef(function FooterContactActions(
  { email, phone, ...props },
  ref,
) {
  return (
    <Stack
      justify={{ sm: 'center', md: 'start' }}
      wrap="wrap"
      gap={3 * 4}
      {...props}
      ref={ref}
    >
      <Button
        as="a"
        size="lg"
        variant="primary"
        iconStart={<Mail className="h-4 w-4" />}
        href={`mailto:${email}`}
      >
        {email}
      </Button>
      <Button
        as="a"
        size="lg"
        variant="outline"
        iconStart={<Phone className="h-4 w-4" />}
        href={`tel:${phone}`}
      >
        {phone}
      </Button>
    </Stack>
  )
}) as Polymorphic<'div', FooterContactActionsProps>
